import { Assignment as AssignmentIcon } from "@mui/icons-material";
import StatCard from "../../ui/cards/StatCard";
import { useActiveUserWorks } from "../../../hooks/useActiveUserWorks";
import { WorkStateEnum } from "../../../store/types/work.types";

const OpenWorksCard = () => {
  const { data = [], isFetching } = useActiveUserWorks({
    state: WorkStateEnum.Open,
  });

  return (
    <StatCard
      icon={<AssignmentIcon />}
      title="Öppna ärenden"
      color="#1976d2"
      description={`${data.length} st`}
      to="/works"
      loading={isFetching}
    />
  );
};

export default OpenWorksCard;
